import axios from "axios";
export function filter(context, { keyword }) {
  context.commit("setPagination", 1);
  context.commit("setFilterKeyword", keyword);
  context.dispatch("fetch");
}
export function order(context, orderOptions) {
  context.commit("setPagination", 1);
  context.commit("setOrder", orderOptions);
  context.dispatch("fetch");
}

export function resetFilters(DEFAULT_VALUES) {
  return function (context) {
    context.commit("setPagination", 1);
    context.commit("setResultsPerPage", 12);
    context.commit("setOrder", {
      order: DEFAULT_VALUES.order,
      direction: DEFAULT_VALUES.orderDirection,
    });
  };
}

export function setResultsPerPage(context, perPage) {
  context.commit("setResultsPerPage", perPage);
}
export function setPagination(context, page) {
  context.commit("setPagination", page);
}
//获取datahub上发布的图层数据
export function fetch(context) {
  const baseURL = "https://alpha.deep-time.org";
  const url = "/v1.0/api/data-central/atom/list/public";
  const reqConfig = {
    method: "post",
    baseURL,
    url,
    params: {
      official: 2,
      keyword: context.state.filterKeyword,
      datasetId: 222,
    },
  };
  context.commit("setFetchingState");
  axios(reqConfig)
    .then((resp) => {
      const { data } = resp;
      context.commit("setLayers", data);
      context.commit("setPagination", context.state.page);
    })
    .catch((err) => {
      context.commit("setRequestError", err);
    });
}
export function updateVisualization(context, visualizationOptions) {
  context.commit("updateVisualization", visualizationOptions);
}
export function addToEarth({dispatch,commit,state}, mapId) {
  commit("addToEarth",mapId)
  const updateAttrs = {
        visualizationId: mapId,
        visualizationAttributes: { added_to_map: true },
  };
  dispatch("updateVisualization", updateAttrs);
  const map = state.addedList.find( m => m.id === mapId)
  if (map) {
    commit("maps/addToOrderList",map,{root: true})
  }
}

export function removeFromEarth({dispatch,commit}, mapId) {
  commit("removeFromEarth",mapId)
  const updateAttrs = {
        visualizationId: mapId,
        visualizationAttributes: { added_to_map: false },
  };
  dispatch("updateVisualization", updateAttrs);
  commit("maps/removeFromOrderList",mapId,{root: true})
}